module.exports = __webpack_public_path__ + "static/media/inboxIcon.bc872a9c.svg";